import React, { useContext, useState, useEffect, useMemo } from "react";
import { Box, CircularProgress, Grid, Paper, TextField, MenuItem, Typography, Button, Chip } from "@mui/material";
import MyTable from "../../components/Schedule/MyTable";
import { useSnackbar } from "notistack";
import ApiService from "../../functions/apiService";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import StatusInTable from "../../components/StatusInTable/StatusInTable";
import AuthContext from "../../context/AuthContext";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import AcceptShiftHeader from "./AcceptShiftHeader";
import { Row, Col } from "react-bootstrap";
import '../../components/Layout/layout.css'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { toast } from "react-toastify";
import moment from "moment";
import { varFormatTime } from "../../utils/helperFunctions";

const AcceptShiftsMobile = () => {
    const { user, pages, pagesName, v3Data } = useContext(AuthContext);
    let pageView = Object.keys(pagesName).includes("V3_ACCEPT_SHIFT_VIEW") ? pagesName.V3_ACCEPT_SHIFT_VIEW : "normal";
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [rows2, setRows2] = useState([]);
    const [type, setType] = useState(1);
    const [saving, setSaving] = useState(false);
    const [acceptLength, setAcceptLength] = useState(0);
    const [swapsLength, setSwapsLength] = useState(0);
    const [dropdownArr, setDropdownArr] = useState([])
    const [dropdownMax, setDropdownMax] = useState(25)
    const [preferenceArr, setPreferenceArr] = useState([])
    const [reload, setReload] = useState(false)
    const [offered, setOffered] = useState(0);
    const [showText, setShowText] = useState(false)
    const [rfpText, setRfpText] = useState('')
    const [rfpData, setRfpData] = useState([])
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [overtimeSwaps, setOverTimeSwaps] = useState([]);
    const [overtimeSwapsLength, setOverTimeSwapsLength] = useState(0);
    const [rows3, setRows3] = useState([]);
    const [rows4, setRows4] = useState([]);
    const [rows5, setRows5] = useState([]);
    const [posLength, setPosLength] = useState(0);
    const [viewType, setViewType] = useState('offered')
    const [callBackLength, setCallBackLength] = useState(0);
    const [values, setValues] = useState(v3Data?.CALLBACK_TEMPLATE_PAGE === 'true' ? 4 : 0);

    const loadData = () => {
        setLoading(true);
        ApiService.get("/openShift")
            .then(({ data }) => {
                setRows(data.Schedule);
                setLoading(false);
                const requestedArray = data.Schedule.flatMap(scheduleItem =>
                    scheduleItem.RequestArray.filter(item => item.StatusCode === "Offered")
                );
                setAcceptLength(requestedArray.length);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        loadData();
    }, []);

    const filterFunc = (obj, caseNum) => {
        let newArr;
        if (caseNum === 2) {
            newArr = obj.RequestArray.filter((row) => row.StatusCode === "O");
        } else {
            newArr = obj.RequestArray.filter((row) => row.StatusCode == "Offered");
        }
        return { ...obj, RequestArray: newArr };
    };

    const filteredRows = useMemo(() => {
        if (!rows || rows.length === 0) return [];

        switch (type) {
            case 1:
                return rows.map((r) => filterFunc(r, 3)).filter(r => r.RequestArray.length > 0);
            case 2:
                return rows.map((r) => filterFunc(r, 2)).filter(r => r.RequestArray.length > 0);
            case 3:
                return rows;
            default:
                return [];
        }
    }, [rows, type]);

    const formatDate = (dateObj) => {
        let day = String(dateObj.getDate());
        let formattedDay = day;
        let dateStr = String(dateObj);
        const dateStrArr = dateStr.split(" ");

        if (day.endsWith("1") && day !== "11") {
            formattedDay += "st";
        } else if (day.endsWith("2") && day !== "12") {
            formattedDay += "nd";
        } else if (day.endsWith("3") && day !== "13") {
            formattedDay += "rd";
        } else {
            formattedDay += "th";
        }
        return `${dateStrArr[0]} ${formattedDay} ${dateStrArr[1]} ${dateStrArr[3]}`;
    };

    const acceptOpenShift = (row) => {
        //openShiftTimerAction
        setSaving(true);
        ApiService.post("/openShiftTimerAction", {
            Action: "accept",
            EmpCode: row.EmpCode,
            ShiftCode: row.ShiftNumber,
            ShiftDate: row.ShiftDate,
        })
            .then((data) => {
                setSaving(false);
                loadData();
                toast.success(data?.message)
            })
            .catch((error) => {
                setSaving(false);
                if (error.data != undefined) {
                    toast.error(error?.data?.message || error?.data || 'error')
                } else {
                    toast.error("Error")
                }

            });
    };

    const RejectShift = (row) => {
        setSaving(true);
        ApiService.post("/rejectShift", {
            Action: "reject",
            EmpCode: row.EmpCode,
            Shift_Number: row.ShiftNumber,
            Shift_Date: row.ShiftDate,
        })
            .then((data) => {
                setSaving(false);
                loadData();
                toast.success(data?.message)
            })
            .catch((error) => {
                setSaving(false);
                if (error.data != undefined) {
                    toast.error(error?.data?.message)
                } else {
                    toast.error("Error")
                }

            });
    };

    useEffect(() => {
        var tempArr = []
        for (let i = 1; i <= dropdownMax; i++)(
            tempArr.push({ label: `Pref ${i}`, value: i })
        )
        setDropdownArr(tempArr)
    }, [])

    useEffect(() => {
        let tempArr = []
        filteredRows?.length > 0 && filteredRows?.map((item) => {
            item.RequestArray.length > 0 && item?.RequestArray.map((obj, i) => {
                if (obj?.PreferenceData) {
                    let newObj = { shift: obj?.ShiftCode, pref: obj?.PreferenceData?.Value, date: obj?.ShiftDate, isDetail: obj?.DetailType != null }
                    tempArr.push(newObj)
                }
            })
        })
        setPreferenceArr(tempArr)
    }, [filteredRows])

    return (
        <>
            <Paper className="p-3" style={{ maxWidth: '93vw', overflowX: 'auto', }}>
                <div className="accept-container">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className='my-shifts'>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="h5">Accept Shifts</Typography>
                                    </Grid>
                                </Grid>
                            </div>

                            {values == 0 &&
                                <div>
                                    {loading && (
                                        <Box className="w-100 d-flex justify-content-center align-items-center"
                                            style={{ height: '500px' }}>
                                            <CircularProgress />
                                        </Box>
                                    )}

                                    {!loading &&
                                        <>
                                            <Box
                                                sx={{
                                                    maxWidth: "93vw",
                                                    overflowX: "auto",
                                                    background: "#FFF",
                                                }}
                                            >
                                                <Grid container spacing={2} className='mt-1'>
                                                    {rows.length > 0 ? (
                                                        filteredRows.map((obj) => {
                                                            const d = new Date(obj.Date + "T00:00:00");
                                                            let newDate = formatDate(d);
                                                            if (obj.RequestArray.length > 0) {
                                                                return (
                                                                    <>
                                                                        <Grid item xs={12}>
                                                                            <Box
                                                                                sx={{
                                                                                    padding: '16px',
                                                                                    backgroundColor: '#ffffff',
                                                                                    borderRadius: '12px',
                                                                                    border: '1px solid #EBECF0',
                                                                                }}>
                                                                                <TableContainer>
                                                                                    <Table aria-label="simple table">
                                                                                        <TableHead>
                                                                                            <TableRow>
                                                                                                <TableCell align="left" style={{ padding: '0px', paddingBottom: '16px', fontSize: '16px', fontWeight: 550, fontFamily: 'karla' }}>
                                                                                                    Shift
                                                                                                </TableCell>
                                                                                                <TableCell align="right" style={{ fontSize: '16px', fontWeight: 550, fontFamily: 'karla', padding: '0px', paddingBottom: '16px', }}>
                                                                                                    {moment(obj.Date).format('MM/DD/YY')}
                                                                                                </TableCell>
                                                                                            </TableRow>
                                                                                        </TableHead>

                                                                                        <TableBody>
                                                                                            {obj.RequestArray.map((row) => (
                                                                                                <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                                                    <TableCell
                                                                                                        component="th"
                                                                                                        scope="row"
                                                                                                        style={{
                                                                                                            padding: '0px',
                                                                                                            fontSize: '16px',
                                                                                                            fontWeight: 600,
                                                                                                            fontFamily: 'karla',
                                                                                                            padding: '7px',
                                                                                                            width: '50%'
                                                                                                        }}
                                                                                                    >
                                                                                                        {row?.ShiftType === 'Details' ?
                                                                                                            row?.StartTime >= "08:00:00" && row?.StartTime <= "17:59:59" ? `Day (${varFormatTime(row?.ShiftName, user?.Time_Format)})` : `Night (${varFormatTime(row?.ShiftName, user?.Time_Format)})`
                                                                                                            : row?.ShiftType
                                                                                                        }

                                                                                                        {row?.ShiftType === 'Day' &&
                                                                                                            <img src="/images/day.svg" height="20px" width="20px" style={{ marginLeft: '10px' }} />
                                                                                                        }

                                                                                                        {row?.ShiftType === 'Night' &&
                                                                                                            <img src="/images/night.svg" height="18px" width="18px" style={{ marginLeft: '10px' }} />
                                                                                                        }

                                                                                                        {!["Day", "Night"].includes(row?.ShiftType) && (
                                                                                                            <img
                                                                                                                src={
                                                                                                                    row?.StartTime >= "08:00:00" && row?.StartTime <= "17:59:59"
                                                                                                                        ? "/images/day.svg"
                                                                                                                        : "/images/night.svg"
                                                                                                                }
                                                                                                                height="20px"
                                                                                                                width="20px"
                                                                                                                style={{ marginLeft: "10px" }}
                                                                                                            />
                                                                                                        )}
                                                                                                    </TableCell>

                                                                                                    <TableCell align="right" style={{ padding: '0px', padding: '7px 0px' }}>
                                                                                                        {row.EmpCode !== user.Emp_Code && (
                                                                                                            <>
                                                                                                                {values === 0 && row.StatusCode === 'Offered' && (
                                                                                                                    <div style={{ display: 'flex', marginTop: '4px' }}>
                                                                                                                        <ButtonTheme
                                                                                                                            disable={saving}
                                                                                                                            color="DarkGreen"
                                                                                                                            className="rounded-2 mx-2 px-3"
                                                                                                                            onClick={() => acceptOpenShift(row)}>
                                                                                                                            Accept
                                                                                                                        </ButtonTheme>

                                                                                                                        <ButtonTheme
                                                                                                                            disable={saving}
                                                                                                                            color="red"
                                                                                                                            className="rounded-2 px-3"
                                                                                                                            onClick={() => RejectShift(row)}>
                                                                                                                            Reject
                                                                                                                        </ButtonTheme>
                                                                                                                    </div>
                                                                                                                )}
                                                                                                                {values === 0 && row.StatusCode === 'O' && (
                                                                                                                    <div className="d-flex justify-content-end" style={{ gap: 10 }}>
                                                                                                                        <ButtonTheme
                                                                                                                            disable={saving}
                                                                                                                            color="red"
                                                                                                                            className="rounded-2"
                                                                                                                            style={{ padding: '6px 34px' }}
                                                                                                                        >
                                                                                                                            Open Position
                                                                                                                        </ButtonTheme>
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            ))}
                                                                                        </TableBody>
                                                                                    </Table>
                                                                                </TableContainer>
                                                                            </Box>
                                                                        </Grid>
                                                                    </>
                                                                );
                                                            }
                                                        })
                                                    ) : (
                                                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 425, width: "100%" }}>
                                                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                                                            <span className='mt-4' style={{ color: '#555555' }}>
                                                                No Shifts Found
                                                            </span>
                                                        </div>
                                                    )}
                                                </Grid>
                                            </Box>
                                        </>
                                    }

                                    {filteredRows.length === 0 && rows.length > 0 &&
                                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 425, width: "100%" }}>
                                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                                            <span className='mt-4' style={{ color: '#555555' }}>
                                                No Shifts Found
                                            </span>
                                        </div>
                                    }
                                </div>
                            }
                        </Grid>
                    </Grid>
                </div>
            </Paper>
        </>
    );
};

export default AcceptShiftsMobile;